import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const SearchInputSearches = ({
  search,
  onClick,
  pin,
  transparent,
}) => (
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/no-static-element-interactions */
  <div
    className={classnames('tag', { 'tag-transparent': transparent })}
    onClick={() => onClick(search.filters, search.type)}
  >
    {pin && (
      <span
        className="pinned-search-icon"
      >
        <i
          className="far fa-thumbtack fa-rotate-by"
          style={{ '--fa-rotate-angle': '45deg' }}
        />
      </span>
    )}
    <span
      className="pinned-search-name"
    >
      {search.name}
    </span>
  </div>
  /* eslint-enable jsx-a11y/click-events-have-key-events */
  /* eslint-enable jsx-a11y/no-static-element-interactions */
);

SearchInputSearches.propTypes = {
  search: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  pin: PropTypes.bool,
  transparent: PropTypes.bool,
};

SearchInputSearches.defaultProps = {
  onClick: () => {},
  pin: true,
  transparent: false,
};

export default SearchInputSearches;
